import React from "react";
import { Grid, Typography } from "@mui/material";
import { getLocalDate } from "../../../../utils/dateHelper";
import { conditionTitles } from "../../../../enums";
import useClinic from "../../../../hooks/useClinic";

const CommentCard = ({ creationDate, comment, prevConditions, conditions }) => {
  const { clinicTimezone } = useClinic();

  const positiveConditions = [];
  conditions.forEach((condition) => {
    if (!prevConditions.includes(condition)) positiveConditions.push(condition);
  });
  const negativeConditions = [];
  prevConditions.forEach((prevCondition) => {
    if (!conditions.includes(prevCondition))
      negativeConditions.push(prevCondition);
  });

  const positiveStatusText = positiveConditions.length
    ? `${getLocalDate(creationDate, clinicTimezone)} : Status of ${positiveConditions.map(
        (condition, i) => {
          return i
            ? " " + conditionTitles[condition]
            : conditionTitles[condition];
        }
      )} changed to be positive.`
    : null;
  const negativeStatusText = negativeConditions.length
    ? positiveConditions.length === 0
      ? `${getLocalDate(creationDate, clinicTimezone)} :`
      : "" +
        `Status of ${negativeConditions.map((condition, i) => {
          return i
            ? " " + conditionTitles[condition]
            : conditionTitles[condition];
        })} changed to be negative.`
    : null;

  const commentContent =
    (!positiveConditions.length && !negativeConditions.length
      ? `${getLocalDate(creationDate, clinicTimezone)} : `
      : "") + comment;

  return (
    <Grid item pl={1} pr={1} pt={0.5} xs={12} mb={0.5} overflow="auto">
      {positiveStatusText && (
        <Typography variant="body1" style={{ wordWrap: "break-word" }}>
          {positiveStatusText}
        </Typography>
      )}
      {negativeStatusText && (
        <Typography variant="body1" style={{ wordWrap: "break-word" }}>
          {negativeStatusText}
        </Typography>
      )}
      <Typography variant="body1" style={{ wordWrap: "break-word" }}>
        {commentContent}
      </Typography>
    </Grid>
  );
};

export default CommentCard;
